module.exports = __webpack_public_path__ + "assets/ed1535ba4d01e31880ae0f7a63f47f73.mp3";